/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_NewInputs */

const en_usage_new = /** @type {(inputs: Usage_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`new`)
};

const fr_usage_new = /** @type {(inputs: Usage_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nouveau`)
};

const de_usage_new = /** @type {(inputs: Usage_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`neu`)
};

const it_usage_new = /** @type {(inputs: Usage_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nuovo`)
};

const ru_usage_new = /** @type {(inputs: Usage_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`новый`)
};

const es_usage_new = /** @type {(inputs: Usage_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nuevo`)
};

const zh_cn2_usage_new = /** @type {(inputs: Usage_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新的`)
};

const ja_usage_new = /** @type {(inputs: Usage_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい`)
};

const hi_usage_new = /** @type {(inputs: Usage_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया`)
};

const pt_pt2_usage_new = /** @type {(inputs: Usage_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`novo`)
};

/**
* | output |
* | --- |
* | "new" |
*
* @param {Usage_NewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_new = /** @type {((inputs?: Usage_NewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_NewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage_new(inputs)
	if (locale === "de") return de_usage_new(inputs)
	if (locale === "it") return it_usage_new(inputs)
	if (locale === "ru") return ru_usage_new(inputs)
	if (locale === "es") return es_usage_new(inputs)
	if (locale === "zh-CN") return zh_cn2_usage_new(inputs)
	if (locale === "ja") return ja_usage_new(inputs)
	if (locale === "hi") return hi_usage_new(inputs)
	if (locale === "pt-PT") return pt_pt2_usage_new(inputs)
	return en_usage_new(inputs)
});